export enum DropTypeEnum {
  NO_DROP = "NO_DROP",
  KANBAN_RIDE_DROP = "KANBAN_RIDE_DROP",
  CARD_BOARD_RIDE_DROP = "CARD_BOARD_RIDE_DROP",
  GRID_STATION_DROP = "GRID_STATION_DROP",
  GRID_RIDE_DROP = "GRID_RIDE_DROP",
  NAV_PLUS_BUTTON = "NAV_PLUS_BUTTON_DROP",
  STATION_DROP = "STATION_DROP",
}
